import { useProfile } from "../stores/useProfile"

export const useNavbar = () => {
    const {user} = useProfile();

     const Navlinks = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Info",
    path: "/info",
  },
  {
    title: "Kunstwerken",
    path: "/gallery",
  },
  {
    title: "Expo's",
    path: "/expos",
  },
  {
    title: "Contact",
    path: "/contact",
  },
  {
    title: user ? "Adminpaneel" : "Login",
    path: "/login",
  },
];

return {Navlinks}
}